<div class="header mt-md-5">
  <a [routerLink]="'/calculations'" class="d-print-none" href=""><i class="fa fa-chevron-left"></i> Retour à
l'historique des calculs</a>

<div class="header-body">

  <div class="row align-items-center calculation-status-bar">
    <div class="col">

      <!-- Title -->
      <ng-container>
        @if (isTitleInEditingMode) {
          <form class="d-flex flex-row mb-4">
            <div class="pe-2 flex-grow-1">
              <input [class.is-invalid]="this.calculationTitleUpdateForm.formElements.title.state === 'ERROR'"
                [class.is-valid]="this.calculationTitleUpdateForm.formElements.title.state === 'VALID' || this.calculationTitleUpdateForm.formElements.title.lifecycleStatus === 'SENDING'"
                [formControl]="getTitleFormControl()"
                [readOnly]="this.calculationTitleUpdateForm.formElements.title.lifecycleStatus === 'SENDING' || this.calculationTitleUpdateForm.formElements.title.lifecycleStatus === 'LOADING'"
                class="form-control"
                type="text">
            </div>
            <div class="">
              <magieno-button [button]="this.calculationTitleUpdateForm.getButton('SAVE')"></magieno-button>
              <button (click)="toggleTitleEditingMode()" class="btn btn-link" style="margin-left: 12px">
                Annuler
              </button>
            </div>
          </form>
        }

        @if (!isTitleInEditingMode) {
          <div class="d-flex flex-row mb-4">
            <div class="flex-grow-1">
              <h1 class="header-title d-flex align-items-center">
                {{ calculationTitle }}
                <span [class.bg-danger]="calculationStatusEnum === 'ERROR'"
                  [class.bg-light]="calculationStatusEnum === 'CREATED'"
                  [class.bg-success]="calculationStatusEnum === 'COMPLETED'"
                  [class.bg-warning]="calculationStatusEnum === 'IN_PROGRESS'"
                  class="badge rounded-pill bg-warning d-print-none"
                  style="margin-left: 25px; font-size: 70%;"
                >{{ getStatusText() }}</span>
              </h1>
            </div>
            <button (click)="toggleTitleEditingMode()" class="btn btn-white d-print-none">
              Modifier le titre
            </button>
            <div class="dropdown ps-4 pt-2 pe-3 pe-md-0 d-print-none">
              <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
                data-bs-toggle="dropdown" href="#" role="button">
                <i class="fas fa-lg fa-ellipsis-v"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end mt-3">
                <a (click)="$event.preventDefault(); openImportModal()" class="dropdown-item" href="#">
                  <i class="fas fa-fw fa-file-import me-2"></i> Importer des données
                </a>
                <a (click)="$event.preventDefault(); openExportModal()" class="dropdown-item" href="#">
                  <i class="fas fa-fw fa-cloud-download me-2"></i> Exporter le calcul
                </a>
                <a (click)="$event.preventDefault(); tryDuplicate()" class="dropdown-item" href="">
                  <i class="fas fa-fw fa-copy me-2"></i> Dupliquer le calcul
                </a>
                <hr class="dropdown-divider">
                <a (click)="$event.preventDefault(); openDelegatedAccessModal()" class="dropdown-item"
                  href="">
                  <i class="fas fa-fw fa-user-unlock me-2"></i> Partager ce calcul avec le support Optitax
                </a>
                <hr class="dropdown-divider">
                <a (click)="$event.preventDefault(); tryDelete()" class="dropdown-item text-danger"
                  href="">
                  <i class="fas fa-fw fa-trash-alt me-2"></i> Supprimer ce calcul
                </a>
              </div>
            </div>
          </div>
        }
      </ng-container>

      <div>
        <div class="d-block d-sm-inline mb-3 mb-sm-0">
          <i class="me-2 fas fa-calculator-alt"></i>
          <strong>{{ getTitleText() }}</strong>
        </div>

        <div class="ms-sm-5 d-block d-sm-inline d-print-none">Dernière modification: <strong
        class="lastModifiedText">{{ getLastModifiedText() }}</strong></div>
      </div>

    </div>
  </div> <!-- / .row -->

  <div class="row">
    <div class="col-12">
      <app-alert-messages></app-alert-messages>
    </div>
  </div>

  @if (calculationStatusEnum === 'IN_PROGRESS') {
    <div class="row">
      <div class="col-12">
        <div class="alert bg-primary-subtle">
          <h3><span class="spinner-border spinner-border-sm me-3" role="status"></span> Exécution du calcul en
          cours
        </h3>
        <ngb-progressbar [value]="progress" class="mt-4 progress-sm" type="primary"/>
        <div class="mt-3">Temps restant (estimé): <small>{{ remainingCalculationTime }}</small></div>
      </div>
    </div>
  </div>
}

@if (accessCurrentlyGranted) {
  <div class="row">
    <div class="col-12">
      <div class="alert alert-light mt-2 mb-2">
        <h3><i class="fas fa-fw fa-info-circle me-2"></i> Partage avec le support d'Optitax en cours!</h3>
        <p>Ce calcul est présentement partagé avec le support d'Optitax. Le partage se terminera
          automatiquement
          <strong>{{ this.grantedUntil }}</strong>.</p>
          <button (click)="openDelegatedAccessModal()" class="btn btn-primary btn-sm mt-1">Modifier le partage
          </button>
        </div>
      </div>
    </div>
  }

  <div class="row align-items-center d-print-none">
    <div class="col">

      <!-- Nav -->
      <ul class="nav nav-tabs nav-overflow header-tabs">
        <li class="nav-item">
          <a [class.active]="this.menuService.menuItems['/calculations/:calculationKeyname/:id'].isActive"
            [routerLink]="'/calculations/' + (calculationKeyname) + '/' + (_calculationId)" class="nav-link"
            id="form-tab-link">
            Formulaire
          </a>
        </li>

        <li class="nav-item">
          <a [class.active]="this.menuService.menuItems['/calculations/:calculationKeyname/:id/results'].isActive"
            [routerLink]="'/calculations/' + (calculationKeyname) + '/' + (_calculationId) + '/results'"
            class="nav-link"
            id="results-tab-link">
            Résultats
          </a>
        </li>
      </ul>

    </div>
  </div>
</div>
</div>
